import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Part } from '../../interface/part';

const RESULTS_SIZE = 30;

@Injectable({ providedIn: 'root' })
@Pipe({
  standalone: true,
  name: 'partFilter'
})
export class PartFilterPipe implements PipeTransform {

  transform(parts: Part[], text = '', property = ''): Part[] {
    if (!parts) {
      return [];
    }
    if(!text){
      return parts.slice(0, RESULTS_SIZE);
    }
    text = text.toLowerCase();
    if (property) {
      const filtered: Part[] = [];
      for (let part of parts) {
        if (part[property].toLowerCase().includes(text)) {
          filtered.push(part);
          if (filtered.length == RESULTS_SIZE) {
            break;
          }
        }
      }
      return filtered;
    }

    const normalizedText = this._normalize(text);

    if (text.includes('%')) {
      const terms = normalizedText.split('%').map(t => t.trim()).filter(Boolean);
      if (terms.length === 0) return parts.slice(0, RESULTS_SIZE);
      const filtered: Part[] = [];
      for (const part of parts) {
        const fields = this._searchableFields(part);
        const matchAll = terms.every(term => fields.some(field => field.includes(term)));
        if (matchAll) {
          filtered.push(part);
          if (filtered.length === RESULTS_SIZE) break;
        }
      }
      return filtered;
    }

    const filtered: Part[] = [];
    for (const part of parts) {
      if (this._searchableFields(part).some(field => field.includes(normalizedText))) {
        filtered.push(part);
        if (filtered.length == RESULTS_SIZE) {
          break;
        }
      }
    }
    return filtered;
  }

  private _normalize(value: unknown): string {
    return (value ?? '')
      .toString()
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase();
  }

  private _searchableFields(part: Part): string[] {
    return [
      part.description,
      part.code,
      part.fabricCode,
      part.EANcode,
      part.stubCode,
      part.useIn,
    ].map(field => this._normalize(field));
  }
}
